@if (loaderIcon | async) {
    <app-loader></app-loader>
}
<div class="layout-container">
    <app-operations [isCollapsed]="isCollapsed"></app-operations>
    <div class="main-content">
        <app-top-bar (toggleSidebar)="handleToggle()"></app-top-bar>
        <div class="content-area" [userPermissionHandler]="viewPermissionHandlerData">
            <div class="d-flex justify-content-between align-items-center mb-3">
                <h5 class="fw-semibold">Printer Settings</h5>
            </div>
            <hr />
            <div class="row">
                <div class="col-12 text-start">
                    <ul class="nav nav-tabs custom-tabs">
                        <li class="nav-item">
                            <a class="nav-link active" data-bs-toggle="tab" href="#rentalPrinterSettings">Rental Printer
                                Settings</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" data-bs-toggle="tab" href="#posPrinterSettings">POS Printer Settings</a>
                        </li>
                    </ul>
                    <div class="tab-content">
                        <form [formGroup]="rentalForm" class="tab-pane fade show active" id="rentalPrinterSettings">
                            <div class="mt-2">
                                <div class="card shadow-sm">
                                    <div class="card-body">

                                        <!-- Row 1 -->
                                        <div class="row align-items-center settings-row">
                                            <div class="col-md-12 col-lg-6">
                                                <div class="form-check">
                                                    <input id="previewReceipts" type="checkbox"
                                                        class="form-check-input settings-check"
                                                        formControlName="ReceiptDefaultChecked">
                                                    <label class="form-check-label mb-2" for="previewReceipts">
                                                        Display the Settings for Previewing the Receipts as Selected
                                                    </label>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- Row 2 (checked) -->
                                        <div class="row align-items-center settings-row">
                                            <div class="col-md-12 col-lg-6">
                                                <div class="form-check">
                                                    <input id="previewContracts" type="checkbox"
                                                        class="form-check-input settings-check"
                                                        formControlName="ContractDefaultChecked">
                                                    <label class="mb-2" for="previewContracts">
                                                        Display the Settings for Previewing the Contract as Selected
                                                    </label>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- Row 3 -->
                                        <div class="row align-items-center settings-row">
                                            <div class="col-md-12 col-lg-6">
                                                <div class="form-check">
                                                    <input id="emailReceipts" type="checkbox"
                                                        class="form-check-input settings-check"
                                                        formControlName="EmailReceipt">
                                                    <label class="form-check-label mb-2" for="emailReceipts">
                                                        Email the Receipts After Preview
                                                    </label>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- Row 4 (checked) -->
                                        <div class="row align-items-center settings-row">
                                            <div class="col-md-12 col-lg-6">
                                                <div class="form-check">
                                                    <input id="emailContracts" type="checkbox"
                                                        class="form-check-input settings-check"
                                                        formControlName="EmailContract">
                                                    <label class="form-check-label mb-2" for="emailContracts">
                                                        Email the Contracts After Preview
                                                    </label>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- Row 5 -->
                                        <div class="row align-items-center settings-row">
                                            <div class="col-md-12 col-lg-6">
                                                <div class="form-check">
                                                    <input id="printReceipt" type="checkbox"
                                                        class="form-check-input settings-check"
                                                        formControlName="PrintReceipt">
                                                    <label class="form-check-label mb-2" for="printReceipt">
                                                        Print Rental Receipt Automatically When its Generated
                                                    </label>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- Row 6 -->
                                        <div class="row align-items-center settings-row">
                                            <div class="col-md-12 col-lg-6">
                                                <div class="form-check">
                                                    <input id="printContracts" type="checkbox"
                                                        class="form-check-input settings-check"
                                                        formControlName="PrintContract">
                                                    <label class="form-check-label mb-2" for="printContracts">
                                                        Print Contracts Automatically When it is Generated
                                                    </label>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- Row 7 -->
                                        <div class="row align-items-center settings-row">
                                            <div class="col-md-6">
                                                <label class="mb-2" for="copiesToPrint">
                                                    No. of Copies to Print
                                                </label>
                                            </div>
                                            <div class="col-auto text-start">
                                                <input id="copiesToPrint" type="text"
                                                    class="form-control form-control-sm text-center"
                                                    style="width: 100px" formControlName="NumCopies"
                                                    (input)="allowOnlyDigits($event, 5, rentalForm)"
                                                    (blur)="enforceMinCopies()">
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-12 text-start">
                                                <label>Default Rental Notes</label>
                                                <textarea class="form-control"
                                                    formControlName="DefaultRentalNotes"></textarea>
                                            </div>
                                        </div>
                                        <hr />
                                        <div class="row align-items-center mb-3">
                                            <!-- Label -->
                                            <div class="col-auto">
                                                <label for="thermalPrinter" class="col-form-label">
                                                    Select the Default Thermal Printer
                                                </label>
                                            </div>

                                            <!-- Dropdown -->
                                            <div class="col-md-4 col-lg-3">
                                                <select class="form-select" id="thermalPrinter"
                                                    formControlName="RentalThermalPrinter">
                                                    <option *ngFor="let printer of thermalPrinters"
                                                        [value]="printer.Id">
                                                        {{ printer.Name }}
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="px-2">
                                        <table class="table table-borderless table-bordered align-middle">
                                            <thead>
                                                <tr>
                                                    <th>Receipts</th>
                                                    <th class="text-center">Thermal Printer</th>
                                                    <th class="text-center">Logo</th>
                                                    <th class="text-center">No. of Copies</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>Daily Receipts</td>
                                                    <td class="text-center"><input class="form-check-input"
                                                            type="checkbox" formControlName="DailyThermal">
                                                    </td>
                                                    <td class="text-center"><input class="form-check-input"
                                                            type="checkbox" formControlName="DailyLogo"></td>
                                                    <td class="text-center"><input type="text"
                                                            class="form-control text-center"
                                                            formControlName="DailyCopies"
                                                            (input)="allowOnlyDigits($event, 2, rentalForm)">
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Weekly Receipts</td>
                                                    <td class="text-center"><input class="form-check-input"
                                                            type="checkbox" formControlName="WeeklyThermal">
                                                    </td>
                                                    <td class="text-center"><input class="form-check-input"
                                                            type="checkbox" formControlName="WeeklyLogo"></td>
                                                    <td class="text-center"><input type="text"
                                                            class="form-control text-center"
                                                            formControlName="WeeklyCopies"
                                                            (input)="allowOnlyDigits($event, 2, rentalForm)">
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Monthly Receipts</td>
                                                    <td class="text-center"><input class="form-check-input"
                                                            type="checkbox" formControlName="MonthlyThermal">
                                                    </td>
                                                    <td class="text-center"><input class="form-check-input"
                                                            type="checkbox" formControlName="MonthlyLogo"></td>
                                                    <td class="text-center"><input type="text"
                                                            class="form-control text-center"
                                                            formControlName="MonthlyCopies"
                                                            (input)="allowOnlyDigits($event, 2, rentalForm)">
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Delete Receipts</td>
                                                    <td class="text-center"><input class="form-check-input"
                                                            type="checkbox" formControlName="DeleteRentalThermal">
                                                    </td>
                                                    <td class="text-center"><input class="form-check-input"
                                                            type="checkbox" formControlName="DeleteRentalLogo"></td>
                                                    <td class="text-center"><input type="text"
                                                            class="form-control text-center"
                                                            formControlName="DeleteRentalCopies"
                                                            (input)="allowOnlyDigits($event, 2, rentalForm)">
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Void Receipts</td>
                                                    <td class="text-center"><input class="form-check-input"
                                                            type="checkbox" formControlName="VoidRentalThermal">
                                                    </td>
                                                    <td class="text-center"><input class="form-check-input"
                                                            type="checkbox" formControlName="VoidRentalLogo"></td>
                                                    <td class="text-center"><input type="text"
                                                            class="form-control text-center"
                                                            formControlName="VoidRentalCopies"
                                                            (input)="allowOnlyDigits($event, 2, rentalForm)">
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Payment Receipts</td>
                                                    <td class="text-center"><input class="form-check-input"
                                                            type="checkbox" formControlName="PaymentThermal">
                                                    </td>
                                                    <td class="text-center"><input class="form-check-input"
                                                            type="checkbox" formControlName="PaymentLogo"></td>
                                                    <td class="text-center"><input type="text"
                                                            class="form-control text-center"
                                                            formControlName="PaymentCopies"
                                                            (input)="allowOnlyDigits($event, 2, rentalForm)">
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <div class="m-3">
                                            <div class="row align-items-center settings-row">
                                                <div class="col-md-6 d-flex align-items-center mt-2">
                                                    <label class="mb-0" for="merchantCopy">Merchant Copy for online CC
                                                        Payment Receipts</label>
                                                    <input id="merchantCopy" type="checkbox"
                                                        class="form-check-input settings-check ms-4"
                                                        formControlName="RentalMerchantCopy" />
                                                </div>
                                                <div class="col-md-6 d-flex align-items-center mt-2">
                                                    <label for="merchantCopies" class="mb-0">No. of Copies</label>
                                                    <input id="merchantCopies" type="text"
                                                        class="form-control form-control-sm ms-5 text-center"
                                                        style="width: 100px" formControlName="RentalMerchantCopies"
                                                        (input)="allowOnlyDigits($event, 2, rentalForm)" />
                                                </div>
                                            </div>
                                            <div class="row align-items-center settings-row">
                                                <div class="col-md-6 d-flex align-items-center mt-2">
                                                    <label class="mb-0" for="customerCopy">Customer Copy for online CC
                                                        Payment Receipts</label>
                                                    <input id="customerCopy" type="checkbox"
                                                        class="form-check-input settings-check ms-4"
                                                        formControlName="RentalCustomerCopy" />
                                                </div>
                                                <div class="col-md-6 d-flex align-items-center mt-2">
                                                    <label for="customerCopies" class="mb-0">No. of Copies</label>
                                                    <input id="customerCopies" type="text"
                                                        class="form-control form-control-sm ms-5 text-center"
                                                        formControlName="RentalCustomerCopies" style="width: 100px"
                                                        (input)="allowOnlyDigits($event, 2, rentalForm)" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                        <form [formGroup]="posForm" class="tab-pane fade" id="posPrinterSettings">
                            <div class="mt-2">
                                <div class="card shadow-sm">
                                    <div class="card-body">
                                        <div class="row align-items-center mb-3">
                                            <!-- Label -->
                                            <div class="col-auto">
                                                <label for="thermalPrinter" class="col-form-label">
                                                    Select the Default Thermal Printer
                                                </label>
                                            </div>

                                            <!-- Dropdown -->
                                            <div class="col-md-4 col-lg-3">
                                                <select class="form-select" id="thermalPrinter"
                                                    formControlName="PosThermalPrinter">
                                                    <option *ngFor="let printer of thermalPrinters"
                                                        [value]="printer.Id">
                                                        {{ printer.Name }}
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                        <table class="table table-borderless table-bordered align-middle">
                                            <thead>
                                                <tr>
                                                    <th>Receipts</th>
                                                    <th class="text-center">Thermal Printer</th>
                                                    <th class="text-center">Logo</th>
                                                    <th class="text-center">No. of Copies</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>Retail Sale</td>
                                                    <td class="text-center"><input class="form-check-input"
                                                            type="checkbox" formControlName="RetailThermal">
                                                    </td>
                                                    <td class="text-center"><input class="form-check-input"
                                                            type="checkbox" formControlName="RetailLogo"></td>
                                                    <td class="text-center"><input type="text"
                                                            class="form-control text-center"
                                                            formControlName="RetailCopies"
                                                            (input)="allowOnlyDigits($event, 2, posForm)">
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Wholesale</td>
                                                    <td class="text-center"><input class="form-check-input"
                                                            type="checkbox" formControlName="WholesaleThermal">
                                                    </td>
                                                    <td class="text-center"><input class="form-check-input"
                                                            type="checkbox" formControlName="WholesaleLogo"></td>
                                                    <td class="text-center"><input type="text"
                                                            class="form-control text-center"
                                                            formControlName="WholesaleCopies"
                                                            (input)="allowOnlyDigits($event, 2, posForm)">
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Online Sale</td>
                                                    <td class="text-center"><input class="form-check-input"
                                                            type="checkbox" formControlName="OnlineSaleThermal">
                                                    </td>
                                                    <td class="text-center"><input class="form-check-input"
                                                            type="checkbox" formControlName="OnlineSaleLogo"></td>
                                                    <td class="text-center"><input type="text"
                                                            class="form-control text-center"
                                                            formControlName="OnlineSaleCopies"
                                                            (input)="allowOnlyDigits($event, 2, posForm)">
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Pending Sale</td>
                                                    <td class="text-center"><input class="form-check-input"
                                                            type="checkbox" formControlName="PendingSaleThermal">
                                                    </td>
                                                    <td class="text-center"><input class="form-check-input"
                                                            type="checkbox" formControlName="PendingSaleLogo"></td>
                                                    <td class="text-center"><input type="text"
                                                            class="form-control text-center"
                                                            formControlName="PendingSaleCopies"
                                                            (input)="allowOnlyDigits($event, 2, posForm)">
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Layaway Down Payment</td>
                                                    <td class="text-center"><input class="form-check-input"
                                                            type="checkbox" formControlName="LayawayDownPaymentThermal">
                                                    </td>
                                                    <td class="text-center"><input class="form-check-input"
                                                            type="checkbox" formControlName="LayawayDownPaymentLogo">
                                                    </td>
                                                    <td class="text-center"><input type="text"
                                                            class="form-control text-center"
                                                            formControlName="LayawayDownPaymentCopies"
                                                            (input)="allowOnlyDigits($event, 2, posForm)">
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Layaway Installment</td>
                                                    <td class="text-center"><input class="form-check-input"
                                                            type="checkbox" formControlName="LayawayInstallmentThermal">
                                                    </td>
                                                    <td class="text-center"><input class="form-check-input"
                                                            type="checkbox" formControlName="LayawayInstallmentLogo">
                                                    </td>
                                                    <td class="text-center"><input type="text"
                                                            class="form-control text-center"
                                                            formControlName="LayawayInstallmentCopies"
                                                            (input)="allowOnlyDigits($event, 2, posForm)">
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Return Sale</td>
                                                    <td class="text-center"><input class="form-check-input"
                                                            type="checkbox" formControlName="ReturnSaleThermal">
                                                    </td>
                                                    <td class="text-center"><input class="form-check-input"
                                                            type="checkbox" formControlName="ReturnSaleLogo"></td>
                                                    <td class="text-center"><input type="text"
                                                            class="form-control text-center"
                                                            formControlName="ReturnSaleCopies"
                                                            (input)="allowOnlyDigits($event, 2, posForm)">
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Void Sale</td>
                                                    <td class="text-center"><input class="form-check-input"
                                                            type="checkbox" formControlName="VoidSaleThermal">
                                                    </td>
                                                    <td class="text-center"><input class="form-check-input"
                                                            type="checkbox" formControlName="VoidSaleLogo"></td>
                                                    <td class="text-center"><input type="text"
                                                            class="form-control text-center"
                                                            formControlName="VoidSaleCopies"
                                                            (input)="allowOnlyDigits($event, 2, posForm)">
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Gift Certificate</td>
                                                    <td class="text-center"><input class="form-check-input"
                                                            type="checkbox" formControlName="GcThermal">
                                                    </td>
                                                    <td class="text-center"><input class="form-check-input"
                                                            type="checkbox" formControlName="GcLogo"></td>
                                                    <td class="text-center"><input type="text"
                                                            class="form-control text-center" formControlName="GcCopies"
                                                            (input)="allowOnlyDigits($event, 2, posForm)">
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <div class="row settings-row mt-3">
                                            <!-- LEFT SIDE: Merchant + Customer -->
                                            <div class="col-md-8">
                                                <!-- Merchant -->
                                                <div class="row align-items-center mb-2">
                                                    <div class="col-md-6 d-flex align-items-center">
                                                        <label class="mb-0" for="merchantCopy">
                                                            Merchant Copy for online CC Payment Receipts
                                                        </label>
                                                        <input id="merchantCopy" type="checkbox"
                                                            class="form-check-input settings-check ms-3"
                                                            formControlName="PosMerchantCopy" />
                                                    </div>

                                                    <div class="col-md-6 d-flex align-items-center">
                                                        <label for="merchantCopies" class="mb-0 me-2">
                                                            No. of Copies
                                                        </label>
                                                        <input id="merchantCopies" type="text"
                                                            class="form-control form-control-sm text-center"
                                                            style="width: 100px" formControlName="PosMerchantCopies"
                                                            (input)="allowOnlyDigits($event, 2, posForm)" />
                                                    </div>
                                                </div>

                                                <!-- Customer -->
                                                <div class="row align-items-center">
                                                    <div class="col-md-6 d-flex align-items-center">
                                                        <label class="mb-0" for="customerCopy">
                                                            Customer Copy for online CC Payment Receipts
                                                        </label>
                                                        <input id="customerCopy" type="checkbox"
                                                            class="form-check-input settings-check ms-3"
                                                            formControlName="PosCustomerCopy" />
                                                    </div>

                                                    <div class="col-md-6 d-flex align-items-center">
                                                        <label for="customerCopies" class="mb-0 me-2">
                                                            No. of Copies
                                                        </label>
                                                        <input id="customerCopies" type="text"
                                                            class="form-control form-control-sm text-center"
                                                            style="width: 100px" formControlName="PosCustomerCopies"
                                                            (input)="allowOnlyDigits($event, 2, posForm)" />
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- RIGHT SIDE: POS Receipt Defaults -->
                                            <div class="col-md-4 ps-md-4 mt-3 mt-md-0">
                                                <!-- <h6 class="mb-2">POS Receipt Default Options</h6> -->

                                                <div class="form-check mb-2">
                                                    <input class="form-check-input" type="checkbox"
                                                        formControlName="PosreceiptDefaultDisplayChecked"
                                                        id="defaultDisplay" />
                                                    <label class="form-check-label" for="defaultDisplay">
                                                        Default Check Display Receipt
                                                    </label>
                                                </div>

                                                <div class="form-check mb-2">
                                                    <input class="form-check-input" type="checkbox"
                                                        formControlName="PosreceiptDefaultPrintChecked"
                                                        id="defaultPrint" />
                                                    <label class="form-check-label" for="defaultPrint">
                                                        Default Check Print Receipt
                                                    </label>
                                                </div>

                                                <div class="form-check">
                                                    <input class="form-check-input" type="checkbox"
                                                        formControlName="PosreceiptDefaultEmailChecked"
                                                        id="defaultEmail" />
                                                    <label class="form-check-label" for="defaultEmail">
                                                        Default Check Email Receipt
                                                    </label>
                                                </div>

                                                <div class="form-check mb-2">
                                                    <input class="form-check-input" type="checkbox"
                                                        formControlName="ThermalFormatReceipt"
                                                        id="thermalFormatReceipt" />
                                                    <label class="form-check-label" for="thermalFormatReceipt">
                                                        Preview Receipt in Thermal Format.
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12 text-end my-3">
                    <ejs-tooltip id="tooltipbtnSave" target="#targetSave" position="LeftCenter"
                        (beforeOpen)="onBeforeOpen($event)">
                        <button id="targetSave" class="btn btnAS me-1" type="button" (click)="save()"
                            [userPermissionHandler]="editPermissionHandlerData">Save</button>
                    </ejs-tooltip>
                    <button class="btn btn-orange" type="button" (click)="cancelChanges()">Cancel</button>
                </div>
            </div>
        </div>
    </div>